import { handleDrawerClose } from '../hookState/ModuleDrawerState';
import { resetSaveAsDraftState } from '../hookState/AgentSaveAsDraftState';
import { getAppNotificationCount } from './notification';
import { setAgentVisible } from '../hookState/AgentState';
import { setActingOnBehalfOfValue } from '../hookState/ActingOnBehalfDropdown';
import { setTheme } from '../hookState/ThemeState';
import { updateModuleState } from '../stores/eventStore';
import Helper from './helper';

export const changeAgentUserHandler = (agentInfo, userEvents) => {
    Helper.setSessionStorage('agentUser', agentInfo);
    Helper.setStorage('UserEvents', userEvents);
    setActingOnBehalfOfValue(true);
    setTheme(userEvents);
    setAgentVisible(agentInfo);
    updateModuleState();
    getAppNotificationCount();
    handleDrawerClose();
    resetSaveAsDraftState();
}